export const breadcrumbList = [
  {
    name: '门店管理',
    path: ''
  },
  {
    name: '数据处理',
    path: ''
  }
]
